import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import api from './utils/api';

const RESIZE_OBSERVER_MESSAGES = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications.'
];

// Suppress ResizeObserver errors from webpack dev server overlay
// These are harmless browser warnings from React Flow (see: https://github.com/xyflow/xyflow/issues/3516)
window.addEventListener('error', (e) => {
  if (RESIZE_OBSERVER_MESSAGES.includes(e.message)) {
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErr) {
      resizeObserverErr.style.display = 'none';
    }
    e.stopImmediatePropagation();
  }
});

// Report uncaught browser errors and unhandled promise rejections to the
// activity log. These are the failures users never write in about.
window.addEventListener('error', (e) => {
  if (RESIZE_OBSERVER_MESSAGES.includes(e.message)) return;
  const location = e.filename ? ` @ ${e.filename.split('/').pop()}:${e.lineno}` : '';
  api.track('error', 'client_error', `${e.message}${location}`);
});

window.addEventListener('unhandledrejection', (e) => {
  const reason = e.reason;
  const message = reason && reason.message ? reason.message : String(reason);
  api.track('error', 'client_error', `Unhandled rejection: ${message}`);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
